module.exports = __webpack_public_path__ + "img/蛋糕.b56263c2.gif";